import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import FeeRateCardNew from '../FeeRateCardNew';
import { ExclamationCircleIcon, TrashIcon } from '@heroicons/react/24/outline';
import { v4 as uuidv4 } from 'uuid';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Spinner,
  Input
} from "@material-tailwind/react";

import { BitcoinNetworkType, signMessage, signTransaction, sendBtcTransaction } from 'sats-connect';
import { useWallet, useWallets } from '@wallet-standard/react';
import toast, { Toaster } from 'react-hot-toast';
import { getDust20SafeTransferPsbt, getDust20FilterUtxos } from '../../util/dust20-api';
import { launchpadTokenRandom } from '../../util/new-api';
import { dust20TransferFee, ownerAddress } from '../../configs/constant';
import { isValidTaprootAddress } from '../../util/inscribe-util';
import { formatAddress, formatInscriptionId } from '../../util/format-data';
import { getBtcUtxos } from '../../util/ordinal';
import { calculateMultiFee, handleAddressUpdate } from '../../util/format-data';
import logoImg from '../../assets/imgs/logo.png';
import { getDust20SplitMergePsbt } from '../../util/dust20-api';

export default function SplitMergeCard(props) {
  const { selectedData, tick } = props
  const { t, i18n } = useTranslation();
  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const feeRates = useSelector(state => state.feeRate);
  const wallet = useSelector(state => state.wallet);

  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(feeRates.Normal);
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState(0);
  const [address, setAddress] = useState('');
  const [available, setAvailable] = useState(0);
  const [utxos, setUtxos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAll, setIsAll] = useState(0);
  const [payLoading, setPayLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [receiveData, setReceiveData] = useState([]);
  const [addressError, setAddressError] = useState('');
  const [amountError, setAmountError] = useState('');
  const [sum, setSum] = useState(0);

  useEffect(() => {
    const updateFees = async () => {
      if (feeRateMode == "Custom") {
        setFeerate(customFee);
      }
      else
      {
        setFeerate(feeRates[feeRateMode]);
        if (customFee == 0) 
        {
          setCustomFee(feeRates["Fast"] + 1);
        }
      }
    }

    updateFees();

  }, [feeRateMode, customFee, feeRates])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  const handleShow = async () => {
    if (selectedData.length == 0) {
      toast.error(t('Select Utxos Error Message'))
      return;
    }
    // setLoading(true);
    setShow(true);
    setSum(selectedData.reduce((total, data) => total + data.amount, 0));
    setAddress('');
    setAmount(0);
    setReceiveData([]);
    // setErrorMessage('');
    // setAddress('');
    // setIsAll(0);
    // setAmount(0);
    // let tempUtxos = await getBtcUtxos(wallet.nostrPaymentAddress);
    // let results = await getDust20FilterUtxos(tempUtxos);
    // setUtxos(results);
    // let sum = 0;
    // for(let temp of results) {
    //   sum += temp.satoshis;
    // }

    // setAvailable(sum / Math.pow(10, 8));
    // setLoading(false);
  }

  const handleAddress = (value) => {
    setAddress(value);
    setAddressError('');
  }

  const handleAmount = (amount) => {
    setAmount(amount);
    setAmountError('');
  }

  const handleAdd = () => {
    if (amount <= 0 || isNaN(parseInt(amount))) {
      setAmountError(t('Insert Valid Amount Error Message'));
      return;
    }
    if (address == '') {
      setAddressError(t('Insert Address Error Message'));
      return;
    }
    if (!isValidTaprootAddress(address)) {
      setAddressError("Please insert valid taproot address!");
      return;
    }

    let currentSum = receiveData.reduce((total, data) => total + data.amount, 0);

    if (currentSum + parseInt(amount) > sum) {
      setAmountError(t('Amount Exceed Approved Amount Error Message'));
      return;
    }
    setReceiveData((prevData) => {
      return [...prevData, {address, amount: parseInt(amount)}];
    });
  }

  const handleRemove = (data) => {
    let tempData = [];
    for(let temp of receiveData) {
      if (temp.address != data.address || temp.amount != data.amount) tempData.push(temp);
    }
    setReceiveData(tempData)
  }

  const handleHide = (e) => {
    e.preventDefault(false);
    setShow(false);
  }

  const handleSetIsAll = () => {
    setIsAll(1);
    setAmount(available);
  }

  const handlePay = async() => {
    setPayLoading(true);

    let currentSum = receiveData.reduce((total, data) => total + data.amount, 0);
    if (currentSum != sum) {
      setErrorMessage(t('Amount Does Not Match Error Message'));
      setPayLoading(false);
      return;
    }
    else {
      setErrorMessage('');
    }
    
    let results = await launchpadTokenRandom(wallet.nostrOrdinalsAddress, 1) // dustzero

    let fundingAmount = 0;
    if (results.data.length == 0) {
      fundingAmount = dust20TransferFee;
    }

    let tempUtxos = await getBtcUtxos(wallet.nostrPaymentAddress);
    results = await getDust20FilterUtxos(tempUtxos);

    let vins = {
      seg: 0,
      tap: selectedData.length,
      leg: 0,
      nesSeg: 0
    };

    let vouts = {
      seg: 0,
      tap: receiveData.length,
      leg: 0,
      nesSeg: 0
    };

    let sats = selectedData[0].value / selectedData[0].amount;

    if (fundingAmount > 0) {
      vouts.tap += 1;
    }

    let totalValue = 0;
    let utxos = [];
    for(let utxo of results) {
      totalValue += utxo.satoshis;
      utxos.push({
        txid: utxo.txid,
        value: utxo.satoshis,
        vout: utxo.vout
      })
      vins = handleAddressUpdate(vins, wallet.nostrPaymentAddress)
      if (totalValue > (calculateMultiFee(vins, vouts, feerate) + fundingAmount)) {
        break;
      }
    }

    let tempVouts = handleAddressUpdate(vouts, wallet.nostrPaymentAddress);
    let charge = totalValue - calculateMultiFee(vins, tempVouts, feerate) - fundingAmount;

    if (totalValue < calculateMultiFee(vins, vouts, feerate) + fundingAmount) {
      setErrorMessage(t('Insufficient Balance Error Message'));
      setPayLoading(false);
      return;
    }
    else {
      setErrorMessage('');
    }

    let fundingAddress = ownerAddress;

    let selectedUtxos = []
    for(let temp of selectedData) {
      selectedUtxos.push({
        txid: temp.output.split(":")[0],
        vout: parseInt(temp.output.split(":")[1]),
        value: temp.value
      })
    }

    let param = {
      selectedData: selectedUtxos,
      receiveData,
      utxos,
      address : wallet.nostrPaymentAddress,
      pubkey : wallet.paymentPublicKey,
      charge,
      fundingAddress,
      fundingAmount,
      provider: wallet.domain,
      sats
    }

    const paymentUtxos = await getDust20SplitMergePsbt(param)

    let isSuccess = true;

    try{
      if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let signIndexes = [];
        for(let i=0;i< utxos.length + selectedData.length; i++){
          signIndexes.push(i);
        }

        await signTransaction({
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: paymentUtxos,
              broadcast: true,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                      address: wallet.nostrPaymentAddress,
                      signingIndexes: signIndexes,
                  },
              ],
          },
          onFinish: async (response) => {
          },
          onCancel: () => {
              setErrorMessage(t('Request canceled'));
              setPayLoading(false);
              isSuccess = false
              return;
          },
        });
       }
      else if (wallet.domain == "magiceden") {
        let signIndexes = [];
        for(let i=0;i<utxos.length + selectedData.length; i++){
          signIndexes.push(i);
        }

        let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

        await signTransaction({
          getProvider: async () =>
            magicedenWallets[0].features['sats-connect:'].provider,
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: paymentUtxos,
              broadcast: true,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                      address: wallet.nostrPaymentAddress,
                      signingIndexes: signIndexes,
                  },
              ],
          },
          onFinish: async (response) => { 
          },
          onCancel: () => {
              setErrorMessage(t('Request canceled'));
              setPayLoading(false);
              isSuccess = false;
              setShow(false);
          },
        });
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setPayLoading(false);
        setShow(false);
        return;
      }
    }
    catch(e)
    {
      setErrorMessage(t('User Reject Request Error Message'));
      isSuccess = false;
      setPayLoading(false);
      return;
    }
    if (isSuccess) {
      setShow(false);
      toast.success(t('Success!'));
    }
    setPayLoading(false);
  }

  return (
    <>
      <div 
        className="flex flex-row gap-1 items-center rounded-md cursor-pointer py-2 px-8 justify-center bg-primary hover:bg-primary-hover" 
        onClick={() => handleShow()}
      >
        <span className = "md:mt-[1px] mt-[2px] font-bold ">
          {t('Split')}&nbsp;/&nbsp;{t('Merge')}&nbsp;/&nbsp;{t('Transfer')}
        </span>
      </div>
      <Dialog
          open={show}
          size={"sm"}
          className="bg-black border-solid border-[1px] border-gray-600"
        >
        <DialogBody>
          <div className = "flex flex-col gap-4 md:p-4 p-1">
            <div className="text-primary font-bold md:text-[32px] text-[24px] text-center ">
              DUST-20 UTXO {t('Split')}&nbsp;/&nbsp;{t('Merge')}&nbsp;/&nbsp;{t('Transfer')}
            </div>
            <div className="flex flex-row text-white text-[20px] font-bold text-center m-auto">
              {sum} {tick}
            </div>
            <div className="flex flex-col gap-2 py-4 md:px-4 px-1 border-solid border-[2px] border-gray-800 rounded-md">
              <Input type="text" color="white" label = {t('Recipient')} className="w-full md:min-w-[500px] min-w-[250px]" value={address} onChange = {(e) => {handleAddress(e.target.value)}}/>
              {
                addressError != '' ? 
                <div className="flex flex-row gap-1 items-center">
                  <ExclamationCircleIcon strokeWidth={3} className="h-6 w-6 text-red-700"/>
                  <div className="text-red-700 font-bold">{addressError}</div>
                </div>
                : <></>
              }
              <Input type="number" color="white" label = {t('Amount')} className="w-full md:min-w-[500px] min-w-[250px]" value={amount} onChange = {(e) => {handleAmount(e.target.value)}}/>
              {
                amountError != '' ? 
                <div className="flex flex-row gap-1 items-center">
                  <ExclamationCircleIcon strokeWidth={3} className="h-6 w-6 text-red-700"/>
                  <div className="text-red-700 font-bold">{amountError}</div>
                </div>
                : <></>
              }
              <div className="flex flex-row justify-end">
                <div className="px-8 py-[6px] rounded-md bg-primary hover:bg-primary-hover text-white font-bold cursor-pointer" onClick={handleAdd}>{t('ADD')}</div>
              </div>
            </div>
            <div className="flex flex-col gap-2 py-4 md:px-4 px-1 border-solid border-[2px] border-gray-800 rounded-md overflow-scroll max-h-[300px]">
              {
                receiveData.length > 0 ? 
                receiveData.map((data) => {
                  return  <div className="flex flex-row gap-2 justify-between items-center text-white" key={uuidv4()}>
                            <div>{formatInscriptionId(data.address)}, {data.amount}</div>
                            <TrashIcon strokeWidth={2} className="h-5 w-5 cursor-pointer text-primary" onClick={() => {handleRemove(data)}}/>
                          </div>
                  }) 
                : 
                <></>
              }
            </div>
            <div className="grid grid-cols-3 gap-3">
              <FeeRateCardNew header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
              <FeeRateCardNew header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
              <FeeRateCardNew header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
            </div>
            {
              feeRateMode == "Custom" ? 
              <div>
                <Slider color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
              </div>
              : 
              <></>
            }
            {
              errorMessage != '' ? 
              <div className="flex flex-row gap-1 items-center">
                <ExclamationCircleIcon strokeWidth={3} className="h-6 w-6 text-red-700"/>
                <div className="text-red-700 font-bold">{errorMessage}</div>
              </div>
              : <></>
            }
            {
              payLoading ?
              <div className="m-auto">
                <Spinner className="h-16 w-16 text-gray-900/50" color="pink"/>
              </div>
              :
              <div className="flex flex-row gap-4 justify-center mt-4">
                <div className="md:px-[52px] px-[32px] py-2 font-bold rounded-md text-white bg-primary cursor-pointer" onClick={() => handlePay()}>{t('SUBMIT')}</div>
                <div 
                  className="md:px-[40px] px-[20px] py-2 font-bold rounded-md text-white bg-gray-800 cursor-pointer" 
                  onClick={(e) => handleHide(e)}>
                  {t('CANCEL')}
                </div>
              </div>
            }
          </div>
        </DialogBody>
      </Dialog>
    </>
  )
}
